import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const CrownIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M35.4876 40.3328H15.5126C14.6201 40.3328 13.6213 39.6315 13.3238 38.7815L4.52631 14.174C3.27256 10.6465 4.73881 9.56276 7.75631 11.7303L16.0438 17.659C17.4251 18.6153 18.9976 18.1265 19.5926 16.5753L23.3326 6.60901C24.5226 3.42151 26.4988 3.42151 27.6888 6.60901L31.4288 16.5753C32.0238 18.1265 33.5963 18.6153 34.9563 17.659L42.7338 12.1128C46.0488 9.73276 47.6426 10.944 46.2826 14.7903L37.6976 38.824C37.3788 39.6315 36.3801 40.3328 35.4876 40.3328Z"
			/>

			<g opacity={0.4}>
				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" d="M13.8125 46.7501H37.1875" />
				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" d="M20.1875 29.7501H30.8125" />
			</g>
		</SvgIcon>
	)
}

export default CrownIconAtom
